/** GA4 event names for the lead-form funnel, sent as `event_name` on `dynamic-event`. */
export const LEAD_FORM_EVENT = {
  view: 'lead-form-view',
  initiated: 'lead-form-initiated',
  fieldInteracted: 'lead-field-interacted',
  fieldCompleted: 'lead-field-completed',
  fieldValidationError: 'lead-field-validation-error',
  submit: 'lead-form-submit',
  success: 'lead-form-success',
  failed: 'lead-form-failed',
  validationFailed: 'lead-validation-failed',
  creationFailed: 'lead-creation-failed',
  creationTimeout: 'lead-creation-timeout',
} as const;

/**
 * Every payload key. Each push sets all of them (unused ones to `undefined`),
 * because GTM's data layer keeps keys from earlier pushes: without the reset a
 * form event would inherit the last field event's `field_id`.
 */
export const LEAD_FORM_PAYLOAD_KEYS = [
  'group',
  'group_name',
  'step_name',
  'text',
  'value',
  'form_id',
  'form_name',
  'form_type',
  'offer_url',
  'form_session_id',
  'page_path',
  'device',
  'ts',
  'field_id',
  'error_type',
  'error_message',
  'trigger',
  'form_fill_duration_ms',
  'validation_result',
  'error_fields',
  'lead_id',
  'submit_response_ms',
] as const;

/** Share of the form that must be on screen for `lead-form-view`. */
export const FORM_VIEW_THRESHOLD = 0.5;
